import { render, staticRenderFns } from "./reportProficientList.vue?vue&type=template&id=21410cd8&scoped=true"
import script from "./reportProficientList.vue?vue&type=script&lang=js"
export * from "./reportProficientList.vue?vue&type=script&lang=js"
import style0 from "./reportProficientList.vue?vue&type=style&index=0&id=21410cd8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_29ccf6a1548590c1291b44f0faebdb79/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21410cd8",
  null
  
)

export default component.exports